/**
 * Lazy loader for Razorpay Checkout.js.
 * Loads the script on first call, reuses it thereafter.
 *
 * Usage (later, inside the booking modal):
 *   const rzp = await openRazorpay({
 *     key: rzp_key_id,                      // from CRM /orders/create response
 *     amount: amount,                       // paise (INR) or smallest unit
 *     currency: "INR",
 *     name: "Wisedrive",
 *     description: "Vehicle Inspection",
 *     order_id: rzp_order_id,
 *     prefill: { name, email, contact },
 *     theme: { color: "#1a56db" },
 *     handler: async (response) => { ... verifyOrder(response) ... },
 *   });
 *   rzp.open();
 */

const SCRIPT_URL = "https://checkout.razorpay.com/v1/checkout.js";
let loaderPromise = null;

function loadScript() {
  if (typeof window === "undefined") return Promise.reject(new Error("no window"));
  if (window.Razorpay) return Promise.resolve(window.Razorpay);
  if (loaderPromise) return loaderPromise;

  loaderPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = SCRIPT_URL;
    s.async = true;
    s.onload = () => resolve(window.Razorpay);
    s.onerror = () => {
      loaderPromise = null;
      reject(new Error("Failed to load Razorpay Checkout"));
    };
    document.body.appendChild(s);
  });
  return loaderPromise;
}

export async function openRazorpay(options) {
  const Razorpay = await loadScript();
  return new Razorpay(options);
}

export default openRazorpay;
